import Admin from "../pages/admin/Admin";

const admin = [
    {
        path: "/admin/*",
        element: <Admin />,
    }
]
export default admin;